var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AttentionModal',{attrs:{"title":_vm.title,"body":_vm.body,"visible":_vm.attentionModalVisible},on:{"close":function($event){_vm.attentionModalVisible = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }